"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelStars = _interopRequireDefault(require("../../HotelStars/HotelStars"));
var _WishListButton = _interopRequireDefault(require("../../WishListButton/WishListButton"));
var _ManagerConsole = _interopRequireDefault(require("../../../icons-react/ManagerConsole"));
var _ManagerEdit = _interopRequireDefault(require("../../../icons-react/ManagerEdit"));
var HotelCartMetaTitle = function HotelCartMetaTitle(_ref) {
  var wishlist = _ref.wishlist,
    _ref$isEmployee = _ref.isEmployee,
    isEmployee = _ref$isEmployee === void 0 ? false : _ref$isEmployee,
    location = _ref.location,
    _ref$onConsoleClick = _ref.onConsoleClick,
    onConsoleClick = _ref$onConsoleClick === void 0 ? function () {
      return undefined;
    } : _ref$onConsoleClick,
    _ref$onEditClick = _ref.onEditClick,
    onEditClick = _ref$onEditClick === void 0 ? function () {
      return undefined;
    } : _ref$onEditClick,
    starCount = _ref.starCount,
    $isMapCard = _ref.$isMapCard;
  return /*#__PURE__*/_react["default"].createElement(StyledRow, {
    $isMapCard: $isMapCard
  }, /*#__PURE__*/_react["default"].createElement(_HotelStars["default"], {
    value: starCount,
    showMeta: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    itemProp: "address",
    itemScope: true,
    itemType: "https://schema.org/PostalAddress"
  }, /*#__PURE__*/_react["default"].createElement(StyledLocationLabel, {
    itemProp: "addressRegion"
  }, location)), /*#__PURE__*/_react["default"].createElement(Icons, null, isEmployee && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onConsoleClick
  }, /*#__PURE__*/_react["default"].createElement(_ManagerConsole["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onEditClick
  }, /*#__PURE__*/_react["default"].createElement(_ManagerEdit["default"], null))), wishlist && /*#__PURE__*/_react["default"].createElement(_WishListButton["default"], wishlist)));
};
var StyledRow = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardMetaTitle__StyledRow",
  componentId: "sc-1gtjp7p-0"
})(["display:flex;margin-bottom:4px;", ";"], function (_ref2) {
  var $isMapCard = _ref2.$isMapCard;
  return $isMapCard && "margin-right: 30px;";
});
var Icons = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardMetaTitle__Icons",
  componentId: "sc-1gtjp7p-1"
})(["margin-left:auto;display:flex;align-items:center;> *{margin-left:8px;}"]);
var StyledLocationLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardMetaTitle__StyledLocationLabel",
  componentId: "sc-1gtjp7p-2"
})(["color:", ";font-size:14px;line-height:1.14;overflow:hidden;text-overflow:ellipsis;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
});
var _default = exports["default"] = HotelCartMetaTitle;